import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="messages"
export default class extends Controller {

  static targets = ['message'];

  static values = {
    items: Array
  }

  connect() {
    this.index = -1;

    let heights = []

    setTimeout(() => {

      this.messageTargets.forEach(element => {
        heights.push(element.clientHeight)

        element.classList.add('loaded')
      })

      this.itemsValue = []

      this.element.style.height = `${Math.max(...heights)}px`

      setTimeout(this.next.bind(this), 100);
    }, 100);
  }

  next() {
    if (this.index >= 0) this.messageTargets[this.index].classList.remove('active')

    if (this.messageTargets.length == this.index + 1) this.index = 0;
    else this.index++;

    this.messageTargets[this.index].classList.add('active');


    setTimeout(this.next.bind(this), 5000)
  }
}
